/**
 * Default: Components / Custom > Content box
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import {getUid} from '@ifabnpm/bootstrap/utils.js';
import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';

// -------
// Public
// -------

const init = () => {
	const collection = SelectorEngine.find('.content-box__media figcaption');

	if (collection.length > 0) {
		const label = (window.pageInstance.tm) ? window.pageInstance.tm.translate('showHideFigCaption') : 'Show/hide figure caption';
		for (const element of collection) {
			const id = element.getAttribute('id') || getUid('figcaption');

			element.setAttribute('id', id);

			const trigger = Manipulator.elementAfter(`<button aria-label="${label}" aria-pressed="false" aria-controls="${id}" class="figcaption-toggle"></button>`, element);

			EventHandler.on(trigger, 'click.figcaption', (event) => {
				event.preventDefault();
				event.stopPropagation();

				const isPressed = Manipulator.getAria(event.target, 'pressed');

				if (isPressed) {
					Manipulator.setAria(event.target, 'pressed', 'false');
					Manipulator.removeClass(element, '-show');
				} else {
					Manipulator.setAria(event.target, 'pressed', 'true');
					Manipulator.addClass(element, '-show');
				}
			});
		}
	}
};

// Export
export default {
	init: init
};
